import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { IRequest } from 'src/app/models/requests';
import { v4 as uuidv4 } from 'uuid';
import { environment } from 'src/app/environments/environments';
@Component({
  selector: 'app-aumye-emergency-respond',
  templateUrl: './aumye-emergency-respond.component.html',
  styleUrl: './aumye-emergency-respond.component.scss',
})
export class AumyeEmergencyRespondComponent implements OnInit {
  requestId: string | null;
  orgId: string | null;
  userId: string | null;
  requestData: IRequest[];
  @ViewChild('RespondDialog', { static: true })
  respondDialog: TemplateRef<any>;

  @ViewChild('FetchingDataDialog', { static: true })
  fetchingDataDialog: TemplateRef<any>;

  @ViewChild('UserAlreadyRespondedDialog', { static: true })
  userAlreadyRespondedDialog: TemplateRef<any>;

  @ViewChild('FetchingDataFailedDialog', { static: true })
  fetchingDataFailedDialog: TemplateRef<any>;

  respondSoSData: any;
  //http://localhost:4200/security/emergency-respond?requestId=1F6EE2A8-5F0F-4B8E-9D57-C8790D28BC5D&orgId=0fc03e5b-7e1c-466e-952b-58368ddfeb83&userId=0ddeb25c-0006-47fb-880d-02e92895abb0
  baseServerURL = environment.apiUrl;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private httpclient: HttpClient
  ) {
    const params = this.route.queryParams.subscribe((params: any) => {
      if (params.requestId) {
        this.requestId = params.requestId;
        this.orgId = params.orgId;
        this.userId = params.userId;
      } else {
      }
    });
  }
  ngOnInit(): void {
    const dialogRef = this.dialog.open(this.fetchingDataDialog, {
      disableClose: true,
    });
    let baseServerURL =
      this.baseServerURL+'GetRequestData?requestId=' +
      this.requestId +
      '&orgId=' +
      this.orgId;
    this.httpclient.get(baseServerURL).subscribe({
      next: (res: any) => {
        dialogRef.close();
        this.requestData = res;
        if (
          this.requestData[0].respondData.some(
            (x) => x.respondUserId.toLowerCase() == this.userId.toLowerCase()
          )
        ) {
          console.warn('This user already responded');
          this.dialog.open(this.userAlreadyRespondedDialog, {
            disableClose: true,
          });
        } else {
          this.respondSOSRequest();
        }
      },
      error: (err: any) => {
        this.dialog.closeAll();
        this.dialog.open(this.fetchingDataFailedDialog, {
          disableClose: true,
        });
      },
    });
  }
  respondSOSRequest() {
    this.dialog.open(this.respondDialog);
    this.respondedUserData();
  }
  respondedUserData() {
    const val: IRequest = this.requestData[0];
    const lat = val.requestLatitude;
    const long = val.requestLongitude;
    const respondId = uuidv4();
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          this.respondSoSData = {
            isClickedRespondee: true,
            orgId: this.orgId,
            userId: this.userId,
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            respondId: respondId,
            request: JSON.stringify(val),
          };
          await this.saveRespondSOS(this.respondSoSData);
          const directionsURL = `https://www.google.com/maps/dir/?api=1&origin=${this.respondSoSData.lat},${this.respondSoSData.lng}&destination=${lat},${long}`;
          this.isNavigationDone = true;
          if (this.isNavigationDone) {
            this.onNavigateToResponderView();
          }
          const confirmation = confirm(`Open directions in default map app?`);
          if (confirmation) {
            window.open(directionsURL, '_blank');
          }
        },
        (error) => {
          window.alert(error);
        }
      );
    } else {
      window.alert('Geolocation is not supported by this browser');
    }
  }
  isNavigationDone = false;
  onNavigateToResponderView() {
    this.router.navigateByUrl(
      'dashboard/emergency?requestId=' + this.requestId
    );
  }
  onNavigateMaps() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const val: IRequest = this.requestData[0];
          const lat = val.requestLatitude;
          const long = val.requestLongitude;
          const directionsURL = `https://www.google.com/maps/dir/?api=1&origin=${position.coords.latitude},${position.coords.longitude}&destination=${lat},${long}`;
          this.isNavigationDone = true;
          if (this.isNavigationDone) {
            this.onNavigateToResponderView();
          }
          const confirmation = confirm(`Open directions in default map app?`);
          if (confirmation) {
            window.open(directionsURL, '_blank');
          }
        },
        (error) => {
          window.alert(error);
        }
      );
    } else {
      window.alert('Geolocation is not supported by this browser');
    }
  }
  async saveRespondSOS(val: any) {
    let baseServerURL = this.baseServerURL+'RespondSoS';
    this.httpclient
      .post(baseServerURL, val, {
        responseType: 'text',
      })
      .subscribe(
        (res) => {
          console.log('Details Saved)');
        },
        (err) => {
          console.log('Details NOT Saved)');
        }
      );
    this.dialog.closeAll();
  }
}
